// Green Florist home v3 (2026-10-15): hero slides (sections/gf-hero-slides) and the open/closed status chip
// (sections/gf-store-closing). Loaded as a module, so it runs once even when both sections include it.

// ---------- hero slides ----------
// Advances on its own (Edward thought a slider that paused on hover was broken); a dot click jumps there and restarts the
// timer; stops while the tab is hidden. The active dot's fill shows the time left (CSS, --gf-hs-step).
function initSlides(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';
  const slides = [...root.querySelectorAll('.gf-hs__slide')];
  const dots = [...root.querySelectorAll('.gf-hs__dot')];
  if (slides.length < 2) return;
  const step = Number(root.dataset.step) || 5000;
  let current = 0;
  let timer = null;

  function show(i) {
    current = i;
    slides.forEach((s, k) => {
      const on = k === i;
      s.classList.toggle('is-on', on);
      s.setAttribute('aria-hidden', String(!on));
      s.querySelectorAll('a').forEach((a) => (a.tabIndex = on ? 0 : -1));
    });
    dots.forEach((d, k) => {
      d.setAttribute('aria-current', String(k === i));
      d.classList.remove('is-running');
    });
    if (dots[i]) {
      void dots[i].offsetWidth; // restart the fill animation
      dots[i].classList.add('is-running');
    }
  }
  function stop() {
    clearInterval(timer);
    timer = null;
  }
  function start() {
    stop();
    timer = setInterval(() => show((current + 1) % slides.length), step);
  }
  dots.forEach((d, k) =>
    d.addEventListener('click', () => {
      show(k);
      start();
    })
  );
  document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
  // Keyboard users: hold the slide while focus is inside it (a slide that moves away would hide the focused button).
  // Mouse hover never pauses.
  root.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) stop(); });
  root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) start(); });
  show(0);
  start();
}

// ---------- open / closed status ----------
// Hours are Monday..Sunday ranges such as "9-19" or "9:30-18" ("-" = closed), always in the shop's time zone.
function parseRange(r) {
  const m = String(r).trim().match(/^(\d{1,2})(?::(\d{2}))?\s*-\s*(\d{1,2})(?::(\d{2}))?$/);
  if (!m) return null;
  return [Number(m[1]) + Number(m[2] || 0) / 60, Number(m[3]) + Number(m[4] || 0) / 60];
}
function fmt(h) {
  const hh = Math.floor(h);
  const mm = Math.round((h - hh) * 60);
  return `${hh}:${String(mm).padStart(2, '0')}`;
}
const STATUS_TEXT = {
  zh: { open: '营业中 · 今天 {close} 关门', soon: '快打烊 · {close} 关门', before: '还没开门 · 今天 {open} 开门', closed: '已打烊 · {day} {open} 开门', tomorrow: '明天', days: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'] },
  tw: { open: '營業中 · 今天 {close} 關門', soon: '快打烊 · {close} 關門', before: '還沒開門 · 今天 {open} 開門', closed: '已打烊 · {day} {open} 開門', tomorrow: '明天', days: ['週一', '週二', '週三', '週四', '週五', '週六', '週日'] },
  en: { open: 'Open now · closes at {close}', soon: 'Closing soon · {close}', before: 'Opens today at {open}', closed: 'Closed · opens {day} at {open}', tomorrow: 'tomorrow', days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] },
};
function initStatus(el) {
  updateStatus(el);
  // Keep it right while the page stays open (e.g. opened at 18:55, still showing at 19:05).
  setInterval(() => { if (!document.hidden) updateStatus(el); }, 60000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateStatus(el); });
}
function updateStatus(el) {
  const T = STATUS_TEXT[el.dataset.lang] || STATUS_TEXT.en;
  const week = (el.dataset.hours || '').split(',').map(parseRange);
  if (week.length !== 7) return;
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kuala_Lumpur', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date())
      .map((p) => [p.type, p.value])
  );
  const order = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const today = order.indexOf(parts.weekday);
  if (today < 0) return;
  const now = Number(parts.hour) + Number(parts.minute) / 60;
  const hours = week[today];
  let text = '';
  let open = false;
  if (hours && now >= hours[0] && now < hours[1]) {
    open = true;
    text = (now >= hours[1] - 0.5 ? T.soon : T.open).replace('{close}', fmt(hours[1]));
  } else if (hours && now < hours[0]) {
    text = T.before.replace('{open}', fmt(hours[0]));
  } else {
    for (let d = 1; d <= 7; d++) {
      const k = (today + d) % 7;
      if (week[k]) {
        text = T.closed.replace('{open}', fmt(week[k][0])).replace('{day}', d === 1 ? T.tomorrow : T.days[k]);
        break;
      }
    }
  }
  if (!text) return;
  el.textContent = text;
  el.classList.toggle('is-open', open);
  el.hidden = false;
}

function init() {
  document.querySelectorAll('[data-gf-slides]').forEach(initSlides);
  document.querySelectorAll('[data-gf-open-status]').forEach((el) => {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    initStatus(el);
  });
}
init();
// Theme editor: sections re-render without a page load.
document.addEventListener('shopify:section:load', init);
